<template>
    <div class="Prototype">
        
        <!-- <Component/> -->
        <!-- <World3D/> -->
        <!-- <DrawLine/> -->
        <!-- <DrawLine4 ref='line' v-if="$route.params.model == 'loom'"/> -->
        <!-- <DrawLine3 ref='line' v-if="$route.params.model != 'loom'"/> -->

        <template v-if="$route.params.model == undefined">
            <DrawLine2 ref='line'/>
            <div class="Prototype__debug" @click="onClick()">EFFACER</div>
        </template>
        
        <VoiceRecorder ref='line' v-if="$route.params.model == 'recorder'"/>
        <OneCircle ref='circle' v-if="$route.params.model == 'circle'"/>
        <Circles ref='circles' v-if="$route.params.model == 'circles'"/>
        
    </div>
</template>

<script>

import gsap from "gsap"
import Component from '@/components/prototype/Component.vue'
import World3D from '@/components/prototype/World3D.vue'
import DrawLine from '@/components/prototype/Line.vue'
import DrawLine2 from '@/components/prototype/Line2.vue'
import DrawLine3 from '@/components/prototype/Line3.vue'
import DrawLine4 from '@/components/prototype/Line4.vue'
import VoiceRecorder from '@/components/prototype/VoiceRecorder.vue'
import Circles from '@/components/prototype/Circles.vue'
import OneCircle from '@/components/prototype/Circle.vue'

export default {

    name: 'Prototype',
    components: { Component, World3D, DrawLine, DrawLine2, DrawLine3, DrawLine4, VoiceRecorder, OneCircle, Circles },
    data: () => ({
        txt: '---'
    }),
    mounted() {
        // document.addEventListener('keyup', this.onKey)

        console.log(this.$route.params.model);

    },
    methods: {
        // onKey(evt) {
        //     console.log(evt);   
        // },


        onClick() {
            // console.log(this.$refs.line);
            this.$refs.line.eraseLine()
        },

    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Prototype
    display block
    position absolute
    top 0
    left 0
    width 100vw
    height 100%

    &__debug
        position fixed
        top 0
        left 0
        border 1px solid red
        padding 0 12px
        color red
        min-width 100px
        text-align center
        z-index 1000

</style>




